import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import axios from "axios";

const OrderConfirmed = () => {
  
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);
  
  const location = useLocation();
  const orderId = location.state?.order_id;
  const userId = localStorage.getItem("user_id");
  // -----------------------------
  // FETCH ORDER BY ID
  // -----------------------------
  const fetchOrder = async () => {
  try {
    const res = await axios.post(
      "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_new_order",
      {
        user_id: userId,
        order_id: orderId,
      },
      {
        headers: { "Content-Type": "application/json" },
      }
    );

    console.log("📦 ORDER CONFIRMED RESPONSE:", res.data);

    if (res.data.status === true && res.data.data.length > 0) {
      setOrder(res.data.data[0]);
    }
  } catch (error) {
    console.error("❌ Order fetch error:", error);
  } finally {
    setLoading(false);
  }
};


  useEffect(() => {
  if (orderId && userId) {
    fetchOrder();
  }
}, [orderId, userId]);

  // -----------------------------
  // SAFETY FALLBACKS
  // -----------------------------
  if (loading) return null;
  if (!order) return null;

  return (
    <div className="confirm-container">
      <div className="confirm-box">
        <div className="check-icon">✔</div>

        <h2 className="confirm-title">Order confirmed</h2>

        <p className="confirm-text">
          Your order <b>{order.order_no}</b> is confirmed. You will receive an
          order confirmation email/SMS shortly with the expected delivery date.
        </p>

        <div className="delivery-box">
          <div className="left">
            <p>
              Delivering to: <br />
              <strong>{order.customer_name}</strong> <br />
              <strong>{order.contact_address}</strong> 
            </p>

            <div className="order-confirmed-btn">
              <Link to="/order">ORDER DETAILS</Link>
            </div>

            <p className="hint">
              You can Track / View / Modify order from orders page.
            </p>
          </div>

          <div className="right">
            <img src="/img/van.jpg" alt="Delivery" />
          </div>
        </div>

        {/* Extra Convenience Box */}
        <div className="convenience-box">
          <div className="left">
            <h4>
              Now pay at your convenience <span className="new-tag">New</span>
            </h4>
            <p>
              Pay online using Pay Now option from orders or Pay on Delivery
              (Cash/UPI).
            </p>
            <a href="#" className="see-how">
              See How
            </a>
          </div>
          <div className="right">
            <img src="/img/payment.webp" alt="Pay Later"/>
          </div>
        </div>

        {/* Buttons Section */}
        <div className="order-confirm-button-row">
          <Link to="/products">
            <button className="order-confirm-btn-outline">
              CONTINUE SHOPPING
            </button>
          </Link>

          <Link to="/order">
            <button className="order-confirm-btn-primary">VIEW ORDER</button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default OrderConfirmed;
